import { ToggleRequirementItem } from './ToggleRequirementItem.tsx';
import { NestedRequirement } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/styles.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	checked: boolean;
	disabled?: boolean;
	onToggle: () => void;
	dataTestId?: string;
}

/** The "Require a certified copy" toggle, nested under the proof it certifies. */
export const CertificationRequirementToggle = ({
	checked,
	disabled,
	onToggle,
	dataTestId,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<NestedRequirement>
			<ToggleRequirementItem
				title={tMipManage('kyc_settings.certification.required.label')}
				description={tMipManage('kyc_settings.certification.required.description')}
				checked={checked}
				disabled={disabled}
				onToggle={onToggle}
				showBorder={false}
				dataTestId={dataTestId}
			/>
		</NestedRequirement>
	);
};
